import { StandingOrderDropdownList } from "./StandingOrderDropdownList";

export default StandingOrderDropdownList;
